import React from 'react';
import './ResultsOverlay.css';
import './GameNotLoaded.css';
import { useTranslation } from 'react-i18next';

function GameNotLoaded({
  store,
  gameError,
}) {

  const { t } = useTranslation();
  const historyBackParam = store?.ref?.telegram?.historyBackParam;

  const text =
    gameError === 'notFound' ? t('inform.game_not_found') :
    gameError === 'strokesError' ? t('inform.strokes_error') : '';

  const closeMiniApp = () => {
    window.Telegram?.WebApp?.close?.();
  };

  const backToHistory = () => {
    if (!historyBackParam) { return; }
    store.navigateToStartParam(historyBackParam);
  };

  return (
    <>
      <div className="overlay-background" />
      <div className="results error-popup">
        <div className="error-popup-header">
          <span className="error-popup-icon">⚠️</span>
          <div className="error-popup-title">{t('inform.load_error_title')}</div>
        </div>

        <div className="error-popup-text">{text}</div>

        <div className="error-popup-actions">
          {historyBackParam && (
            <button
              className="error-popup-button"
              onClick={backToHistory}
            >
              {t('art_history.back_to_history')}
            </button>
          )}
          <button
            className="error-popup-button secondary"
            onClick={closeMiniApp}
          >
            {t('results.close')}
          </button>
        </div>
      </div>
    </>
  );
}

export default GameNotLoaded;
